import {
  cellRenderParseData,
  cellRenderStatus
} from '../../../utils/functions';
import { cellRenderButtonModalSK } from '../../ModalSK/functionModalSK';

/** Список полей */
const columnDataGrid = [
  {
    dataField: 'pieceNumId',
    caption: 'Ключ УЕ',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'plantId',
    caption: 'ID склада',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'qcShopCode',
    caption: 'Код цеха отгрузки',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'qcId',
    caption: '№ СК',
    dataType: 'string',
    cellRender: cellRenderButtonModalSK,
    cssClass: 'td-button-cell-render'
  },
  {
    dataField: 'accountingDate',
    caption: 'Дата СК',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'psStatusNumId',
    caption: 'ID статуса УЕ',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'psStatusName',
    caption: 'Статус УЕ',
    cellRender: cellRenderStatus,
    dataType: 'string'
  },
  {
    dataField: 'soDescrId',
    caption: '№ Заказа',
    dataType: 'string'
  },
  {
    dataField: 'l4SoId',
    caption: '№ СЗ сист.',
    dataType: 'string'
  },
  {
    dataField: 'soLineDescrId',
    caption: 'Позиция заказа',
    dataType: 'string'
  },
  {
    dataField: 'zzordOtsortConf',
    caption: 'Признак ОХ из заказа',
    dataType: 'string'
  },
  {
    dataField: 'productGroupDescription',
    caption: 'Продукт',
    dataType: 'string'
  },
  {
    dataField: 'cgId',
    caption: '№ партии',
    dataType: 'string'
  },
  {
    dataField: 'actualPieceId',
    caption: '№ УЕ',
    dataType: 'string'
  },
  {
    dataField: 'heatId',
    caption: '№ плавки',
    dataType: 'string'
  },
  {
    dataField: 'thick',
    caption: 'Толщина, мм',
    dataType: 'number'
  },
  {
    dataField: 'width',
    caption: 'Ширина, мм',
    dataType: 'number'
  },
  {
    dataField: 'widthFact',
    caption: 'Фактическая ширина',
    dataType: 'number'
  },
  {
    dataField: 'length',
    caption: 'Длина, мм',
    dataType: 'number'
  },
  {
    dataField: 'weightNetto',
    caption: 'Вес нетто, т',
    dataType: 'number'
  },
  {
    dataField: 'weightBrutto',
    caption: 'Вес брутто, т',
    dataType: 'number'
  },
  {
    dataField: 'quantity',
    caption: 'Количество',
    dataType: 'number'
  },
  {
    dataField: 'unitShort',
    caption: 'Единица измерения',
    dataType: 'string'
  },
  {
    dataField: 'vehicleIdIn',
    caption: '№ тс',
    dataType: 'string'
  },
  {
    dataField: 'customerName',
    caption: 'Грузополучатель рус.',
    dataType: 'string'
  },
  {
    dataField: 'customerNameEng',
    caption: 'Грузополучатель анг.',
    dataType: 'string'
  },
  {
    dataField: 'shiptoAddressSo',
    caption: 'Адрес получателя рус.',
    dataType: 'string'
  },
  {
    dataField: 'shiptoAddressEnSo',
    caption: 'Адрес получателя англ.',
    dataType: 'string'
  },
  {
    dataField: 'shiptoStationNameSo',
    caption: 'Ст.назначения',
    dataType: 'string'
  },
  {
    dataField: 'shiptoStationCodeSo',
    caption: 'Код станции назначения',
    dataType: 'string'
  },
  {
    dataField: 'shiptoRailwayNameSo',
    caption: 'ЖД назначения',
    dataType: 'string'
  },
  {
    dataField: 'knotPurposeSo',
    caption: 'Целевой узел',
    dataType: 'string'
  },
  {
    dataField: 'shippingPoint',
    caption: 'Пункт отправки',
    dataType: 'string'
  },
  {
    dataField: 'sapId',
    caption: '№ УЭ SAP',
    dataType: 'string'
  },
  {
    dataField: 'shipmentModeRequirement',
    caption: 'Способ отгрузки',
    dataType: 'string'
  },
  {
    dataField: 'planDatePps',
    caption: 'Плановая дата отгрузки с комбината',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'serialId',
    caption: 'Данные штрих кода для УЭ',
    dataType: 'string'
  },
  {
    dataField: 'rejectedFlag',
    caption: 'Флаг отказа от приемки',
    dataType: 'boolean'
  },
  {
    dataField: 'incomingDate',
    caption: 'Дата приемки на склад',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'incomingTime',
    caption: 'Время приемки на склад',
    dataType: 'string'
  },
  {
    dataField: 'incomingStatus',
    caption: 'Статус принятия УЕ',
    dataType: 'string'
  },

  {
    dataField: 'deliveryId',
    caption: 'Номер поставки',
    dataType: 'string'
  },
  {
    dataField: 'shipperName',
    caption: 'ФИО отгрузившего',
    dataType: 'string'
  },
  {
    dataField: 'invoice',
    caption: 'Номер накладной перв.плеча',
    dataType: 'string'
  },
  {
    dataField: 'wadat_ist',
    caption: 'Дата накладной перв.плеча',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'marka',
    caption: 'Марка стали',
    dataType: 'string'
  },
  {
    dataField: 'stornoFlag',
    caption: 'Изменение СК',
    dataType: 'boolean'
  },
  {
    dataField: 'note',
    caption: 'Комментарий',
    dataType: 'string'
  },
  {
    dataField: 'batchId',
    caption: '№ партии SAP',
    dataType: 'string'
  },
  {
    dataField: 'onHoldFlag',
    caption: 'Карантин',
    dataType: 'boolean'
  },
  {
    dataField: 'decision',
    caption: 'Решение',
    dataType: 'string'
  },
  {
    dataField: 'materialSize',
    caption: 'Профили размера',
    dataType: 'string'
  },
  {
    dataField: 'conservationQmet',
    caption: 'Тип консервации',
    dataType: 'string'
  },
  {
    dataField: 'grPoverh',
    caption: 'Группа поверхности',
    dataType: 'string'
  },
  {
    dataField: 'stockDescr',
    caption: 'Склад',
    dataType: 'string'
  },
  {
    dataField: 'areaDescr',
    caption: 'Зона',
    dataType: 'string'
  },
  {
    dataField: 'boxDescr',
    caption: 'Бокс',
    dataType: 'string'
  }

];

export default columnDataGrid;
